import { render } from "./ScalableModal.vue?vue&type=template&id=07607010&scoped=true"
import script from "./ScalableModal.vue?vue&type=script&lang=js"
export * from "./ScalableModal.vue?vue&type=script&lang=js"

import "./ScalableModal.vue?vue&type=style&index=0&id=07607010&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07607010"]])

export default __exports__